import type { AnalyticsEventContext } from './types';

interface BrowserEventContextSource {
	href: string;
	pathname: string;
	search: string;
	referrer: string;
	title: string;
}

export function snapshotAnalyticsEventContext(
	source: BrowserEventContextSource,
	now = new Date(),
): AnalyticsEventContext {
	return {
		timestamp: now.toISOString(),
		url: source.href,
		path: source.pathname,
		search: source.search,
		referrer: source.referrer || null,
		title: source.title,
	};
}
